<template>
  <div class="p-4">
    <VideoTranscriptRow
      v-for="line in subtitleRows"
      :key="line.start"
      :transcript-row-data="line"
      :player-current-time="playerCurrentTime"
    />
  </div>
</template>

<script setup>
import { useAsyncState, watchImmediate } from '@vueuse/core'
import axios from 'axios'
import { computed, ref } from 'vue'
import { useVideoShow } from '../use-video-show'
import { convertWebvttToData } from './utils'
import VideoTranscriptRow from './video-transcript-row.vue'

const props = defineProps({
  video: {
    required: true,
  },
})
const emit = defineEmits(['subtitle-load-error'])

const { playerRef } = useVideoShow()
const playerCurrentTime = ref(0)

const { state: videoSubtitleContent } = useAsyncState(async () => {
  try {
    const res = await axios.get(props.video.subtitle_url, {
      ignoreGlobalCatch: true,
    })
    return res.data
  }
  catch {
    emit('subtitle-load-error')
    return ''
  }
}, '', {
  immediate: true,
})

const subtitleRows = computed(() => convertWebvttToData(videoSubtitleContent.value))

watchImmediate(playerRef, (player) => {
  if (player) {
    playerCurrentTime.value = player.currentTime()

    player.on('timeupdate', () => {
      playerCurrentTime.value = player.currentTime()
    })
  }
})
</script>
